import axios from 'axios';
import AjaxResponseInterface from '@/interfaces/AjaxResponseInterface';
import ValidationResponseInterface from '@/interfaces/ValidationResponseInterface';
import AjaxErrorResponseInterface from '@/interfaces/AjaxErrorResponseInterface';

export default {
  validate(step: string, data: unknown): Promise<ValidationResponseInterface> {
    return new Promise<ValidationResponseInterface>((resolve, reject) => {
      const { ajaxUrl } = window.ioappConfig;

      axios.post<ValidationResponseInterface>(`${ajaxUrl}?action=solar_lead`, {
        endpoint: 'validate',
        step,
        data,
      }).then((response) => {
        const ajaxResponse = response.data as unknown as AjaxResponseInterface;
        const ajaxResponseData = ajaxResponse.data as ValidationResponseInterface;

        resolve(ajaxResponseData);
      }).catch((e) => {
        const errorResponse = e.response as AjaxErrorResponseInterface;

        reject(errorResponse);
      });
    });
  },
  submit(data: unknown): Promise<ValidationResponseInterface> {
    return new Promise<ValidationResponseInterface>((resolve, reject) => {
      const { ajaxUrl } = window.ioappConfig;

      axios.post<ValidationResponseInterface>(`${ajaxUrl}?action=solar_lead`, {
        endpoint: 'submit',
        data,
      }).then((response) => {
        const ajaxResponse = response.data as unknown as AjaxResponseInterface;
        const ajaxResponseData = ajaxResponse.data as ValidationResponseInterface;

        resolve(ajaxResponseData);
      }).catch((e) => {
        const errorResponse = e.response as AjaxErrorResponseInterface;

        reject(errorResponse);
      });
    });
  },
};
